import $ from 'cash-dom'
import { fetchElevarItemData } from '..'

const elevarDataLayerViewEvent = async (handle: string | false = false) => {
  const elevarItem = await fetchElevarItemData(handle as string)
  if (!elevarItem) return

  const dlList = window.ElevarDataLayer.find((e) => e.event === 'dl_view_item')
    ?.ecommerce?.detail?.actionField?.list

  let path = null
  if (Pura?.template.name === 'collection') {
    path = window.location.pathname
  } else if (Pura?.template.name === 'search') {
    path = `/search${window.location.search}`
  }

  const listPath = dlList || path || ''

  elevarItem.list = listPath

  if (elevarItem) {
    window.ElevarDataLayer.push({
      event: 'dl_view_item',
      ecommerce: {
        currencyCode: 'USD',
        detail: {
          actionField: {
            list: listPath,
          },
          products: [elevarItem],
        },
      },
    })
  }
}

$(() => {
  if (
    Pura?.template.name === 'collection' ||
    Pura?.template.name === 'search'
  ) {
    $(document).on('click', '[data-component="quick-view"]', async (e) => {
      const handle = $(e.currentTarget).data('product-handle')

      if (handle) {
        elevarDataLayerViewEvent(handle)
      }
    })
  }
})

export { elevarDataLayerViewEvent }
